import React from 'react'
import classNames from 'classnames'

export interface IKoubeiInfo {
  structured_info: {
    display_car_name: string
    duration_desc: string
    bought_time_desc: string
    extra_info: {
      text: string
      title: string
    }[]
  } | null
  tag_info_list:
    | {
        Id: number
        TagName: string
      }[]
    | undefined
  append_koubei_list: [] | null
  is_recommend: boolean
  recommend_level: number
  recommend_icon: string
}

interface IProps {
  info: IKoubeiInfo
  isFeed?: boolean
}

export default React.memo(({ info, isFeed }: IProps) => {
  if (!info) return null
  const {
    structured_info,
    tag_info_list,
    append_koubei_list,
    is_recommend,
    recommend_level,
    recommend_icon,
  } = info
  if (!structured_info) return null
  const {
    display_car_name,
    duration_desc,
    bought_time_desc,
    extra_info,
  } = structured_info
  const hasExtraInfo = extra_info && extra_info.length
  return (
    <div className="koubei-info">
      {hasExtraInfo && !isFeed ? (
        <div className="koubei-title">{display_car_name}</div>
      ) : null}
      <div className="structure-info">
        {recommend_icon ? (
          <div
            className="recommend-icon"
            style={{
              backgroundImage: `url(${recommend_icon})`,
            }}
          />
        ) : null}
        {hasExtraInfo ? null : (
          <React.Fragment>
            <div className="koubei-car">{display_car_name}</div>
            <div className="koubei-desc">
              <div className="koubei-time-desc">{bought_time_desc}</div>
              <div className="koubei-duration-desc">{duration_desc}</div>
            </div>
          </React.Fragment>
        )}
        {hasExtraInfo && isFeed ? (
          <React.Fragment>
            <div className="koubei-car">{display_car_name}</div>
            <div className="feed-extra-info-list">
              {extra_info.map((item: any, index: number) => {
                const { text, title } = item
                return (
                  <div className="feed-extra-info-item" key={index}>
                    <div className="feed-extra-info-item-text">{text}</div>
                    <div className="feed-extra-info-item-title">{title}</div>
                  </div>
                )
              })}
            </div>
          </React.Fragment>
        ) : null}
        {hasExtraInfo && !isFeed ? (
          <div className="extra-info-list">
            {extra_info.map((item: any, index: number) => {
              const { text, title } = item
              return (
                <div className="extra-info-item" key={index}>
                  <div className="extra-info-item-text">{text}</div>
                  <div className="extra-info-item-title">{title}</div>
                </div>
              )
            })}
          </div>
        ) : null}
        {tag_info_list && tag_info_list.length ? (
          <div
            className={classNames('tag-list', {
              'top-line': !(extra_info && extra_info.length),
            })}
          >
            {tag_info_list.map(({ TagName, Id }) => (
              <div className="tag-item" key={Id}>
                {TagName}
              </div>
            ))}
          </div>
        ) : null}
      </div>
      <style jsx>
        {`
          .koubei-title {
            height: 48px;
            margin: 24px 0;
            font-size: 34px;
            font-weight: 500;
            line-height: 48px;
            color: #1a1a1a;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .structure-info {
            position: relative;
            padding: 16px;
            background-color: #f7f8fc;
          }
          .recommend-icon {
            position: absolute;
            top: 0;
            bottom: 0;
            margin: auto;
            right: 16px;
            width: 60px;
            height: 60px;
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center;
          }
          .koubei-car {
            margin-bottom: 12px;
            font-size: 20px;
            font-weight: 500;
            color: #1f2129;
            line-height: normal;
          }
          .koubei-desc {
            position: relative;
            display: flex;
            font-size: 14px;
            line-height: 20px;
            color: #979aa8;
          }
          .koubei-time-desc {
            margin-right: 17px;
          }
          .koubei-duration-desc {
            position: relative;
          }

          .extra-info-item {
            display: inline-block;
            width: 130px;
          }
          .extra-info-item-text {
            margin-bottom: 6px;
            font-size: 20px;
            font-weight: bold;
            line-height: 28px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            color: #1a1a1a;
          }
          .extra-info-item-title {
            font-size: 14px;
            line-height: 12px;
            color: #999999;
          }
          .feed-extra-info-item {
            display: inline-block;
            margin-right: 72px;
            font-size: 14px;
            line-height: 1;
          }
          .feed-extra-info-item-text {
            font-size: 16px;
            font-weight: 500;
            line-height: 22px;
            color: #1f2129;
          }
          .feed-extra-info-item-title {
            display: inline-block;
            color: #979aa8;
            font-size: 14px;
            line-height: 20px;
            margin-top: 4px;
          }
          .tag-list {
            position: relative;
            display: flex;
            flex-wrap: wrap;
            margin-top: 16px;
            margin-bottom: -8px;
            padding-top: 24px;
          }
          .tag-list.top-line::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 1px;
            background: #ededed;
          }
          .tag-list .tag-item {
            margin-right: 8px;
            margin-bottom: 8px;
            padding: 7px 16px;
            font-size: 14px;
            line-height: 1;
            color: #1a1a1a;
            border-radius: 16px;
            border: solid 1px #cccccc;
          }
        `}
      </style>
    </div>
  )
})
